import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'antd';
import { SkeletonFormItem } from 'common/components/Skeleton/SkeletonFormItem';
import { getBitecoinSettings } from 'app/store/reducers/bitecoin.reducer';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { GeneralBitecoinSettingsForm } from 'entities/Bitecoin/components/GeneralBitecoinSettingsForm';

export const GeneralBitecoinSettings: React.FC = () => {
  const dispatch = useAppDispatch();
  const [isEditMode, setIsEditMode] = useState(false);
  const { bitecoinSettingsModel, bitecoinSettingsModelLoading } = useAppSelector((state) => state.bitecoin);
  const { pesoToPointRatio, daysBeforeExpiration, walletLimit } = bitecoinSettingsModel || {};

  useEffect(() => {
    dispatch(getBitecoinSettings());
  }, []);

  if (isEditMode) {
    return <GeneralBitecoinSettingsForm setIsEditMode={setIsEditMode} />;
  }

  return (
    <>
      <Row>
        <Col span={24} className="mt-5">
          <span className="basic__text_title" title="Peso-to-point ratio">
            Peso-to-point ratio
          </span>
        </Col>
        <Col span={12}>
          <SkeletonFormItem label="Peso Amount for 1 Bitecoin" boldTitle>
            <span className="font-family__default fs-xxs color-grayDark" title="Peso Amount for 1 Bitecoin">
              {pesoToPointRatio || '-'}
            </span>
          </SkeletonFormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <span className="basic__text_title" title="Peso-to-point ratio">
            Expiry Term
          </span>
        </Col>
        <Col span={12}>
          <SkeletonFormItem label="Days Until Expiry" boldTitle>
            <span className="font-family__default fs-xxs color-grayDark" title="Days Until Expiry">
              {daysBeforeExpiration || '-'}
            </span>
          </SkeletonFormItem>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <span className="basic__text_title" title="Peso-to-point ratio">
            Wallet Limit
          </span>
        </Col>
        <Col span={12}>
          <SkeletonFormItem label="Maximum Bitecoin Limit" boldTitle>
            <span className="font-family__default fs-xxs color-grayDark" title="Maximum Bitecoin Limit">
              {walletLimit || '-'}
            </span>
          </SkeletonFormItem>
        </Col>
      </Row>

      <Col span={12}>
        <Row gutter={[28, 0]}>
          <Col>
            <Button
              onClick={() => setIsEditMode(true)}
              type="primary"
              block
              disabled={bitecoinSettingsModelLoading || !bitecoinSettingsModel}
              loading={bitecoinSettingsModelLoading}
              title="Edit"
            >
              Edit
            </Button>
          </Col>
        </Row>
      </Col>
    </>
  );
};
